export default __webpack_public_path__ + "assets/images/pay_third.6f0b5f.png";